<template>
  <div>
    <Modal :title="type+'个人假期'" :value="value" @on-ok="save" @on-cancel="cancel">
      <Form :model="form" :label-width="130" style="margin:0px 10px 0px -15px" label-position="right" ref="formValidate" :rules="ruleValidate">
        <FormItem label="用户名："  prop="userId">
          <Select v-model="form.userId" :disabled="disabled">
            <Option v-for="(item, index) in fromFields" :value="item.id" :key="index">
              {{
              item.name
              }}
            </Option>
          </Select>
        </FormItem>

        <FormItem label="年份：" prop="year">
          <!-- <Input type="text" placeholder="请输入" v-model="form.year"></Input> -->
          <DatePicker
              type="year"
              @on-change="form.year=$event"
              :value="form.year"
              placeholder="请选择"
              style="width:100%"
              :editable="false"
              :readonly="disabled"
            ></DatePicker>
        </FormItem>
        <FormItem label="年假天数：" >
          <Input type="text" placeholder="请输入" v-model="form.annualLeave"></Input>
        </FormItem>
        <FormItem label="年假已用天数：" >
          <Input type="text" placeholder="请输入" v-model="form.annualLeaveUsed"></Input>
        </FormItem>
        <FormItem label="调休天数：" >
          <Input type="text" placeholder="请输入" v-model="form.overtimeLeave"></Input>
        </FormItem>
        <FormItem label="调休已用天数：" >
          <Input type="text" placeholder="请输入" v-model="form.overtimeLeaveUsed"></Input>
        </FormItem>
        <FormItem label="婚假天数：" >
          <Input type="text" placeholder="请输入" v-model="form.marriageLeave"></Input>
        </FormItem>
        <FormItem label="婚假已用天数：" >
          <Input type="text" placeholder="请输入" v-model="form.marriageLeaveUsed"></Input>
        </FormItem>
        <FormItem label="产假天数：" >
          <Input type="text" placeholder="请输入" v-model="form.maternityLeave"></Input>
        </FormItem>
        <FormItem label="产假已用天数：" >
          <Input type="text" placeholder="请输入" v-model="form.maternityLeaveUsed"></Input>
        </FormItem>
        <FormItem label="丧假天数：" >
          <Input type="text" placeholder="请输入" v-model="form.funeralLeave"></Input>
        </FormItem>
        <FormItem label="丧假已用天数：" >
          <Input type="text" placeholder="请输入" v-model="form.funeralLeaveUsed"></Input>
        </FormItem>
          <FormItem label="过期时间：" prop="expirationTime">
            <DatePicker
              type="date"
              @on-change="form.expirationTime=$event"
              :value="form.expirationTime"
              placeholder="请选择"
              :editable="false"
              style="width:100%"
            ></DatePicker>
          </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancel">取消</Button>
        <Button @click="save" type="primary">确认</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "newdateTable",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    }
  },
  data() {
    return {
      disabled : false,
      ruleValidate: {

			userId: [{ required: true, message: "用户名不能为空", trigger: "change", type: "number"}],

			year: [{required: true, message: "年份不能为空", trigger: "change", type: "string"}],
			
			expirationTime: [{ required: true, message: "过期时间不能为空", trigger: "change"}],

			},
      form: {
        "userId": '',
        "year": '',
        "annualLeave": '',
        "annualLeaveUsed": '',
        "overtimeLeave": '',
        "overtimeLeaveUsed": '',
		"marriageLeave": '',
		"marriageLeaveUsed": '',
        "maternityLeave": '',
        "maternityLeaveUsed": '',
        "funeralLeave": '',
        "funeralLeaveUsed": '',
        "expirationTime": "",
        "MaxResultCount":1000
      },
      fromFields: {},
    };
  },
  mounted() {
    this.indicatorData();
    
  },
  watch: {
    type() {
      if (this.type == "新增") {
        this.form = {
          "userId": '',
          "year": '',
          "annualLeave": '',
          "annualLeaveUsed": '',
          "overtimeLeave": '',
          "overtimeLeaveUsed": '',
			"marriageLeave": '',
			"marriageLeaveUsed": '',
			"maternityLeave": '',
			"maternityLeaveUsed": '',
			"funeralLeave": '',
			"funeralLeaveUsed": '',
          "expirationTime": "",
        };
        this.disabled = false
      }
    }
  },
  methods: {

    //获取下拉框数据
    async indicatorData() {
      let indicatorTable = await this.$Ajax.get(
        "/api/services/app/User/GetAll", {params: this.form}
      );
      this.fromFields = indicatorTable.data.result.items;
    },

    //关闭子组件时
		cancel() {
        this.$emit("close", false);
         this.handTable("formValidate");
      },

		//清空表单数据
		handTable(name) {
      this.$refs[name].resetFields();
      this.form={
        "userId": '',
        "year": '',
        "annualLeave": '',
        "annualLeaveUsed": '',
        "overtimeLeave": '',
        "overtimeLeaveUsed": '',
		"marriageLeave": '',
		"marriageLeaveUsed": '',
        "maternityLeave": '',
        "maternityLeaveUsed": '',
        "funeralLeave": '',
        "funeralLeaveUsed": '',
        "expirationTime": "",
        }
        },

    getParseInt() {
      this.form.annualLeave = parseFloat(this.form.annualLeave)
      this.form.annualLeaveUsed = parseFloat(this.form.annualLeaveUsed)
      this.form.overtimeLeave = parseFloat(this.form.overtimeLeave)
      this.form.overtimeLeaveUsed = parseFloat(this.form.overtimeLeaveUsed)
	  
	  this.form.marriageLeave = parseFloat(this.form.marriageLeave)
	  this.form.marriageLeaveUsed = parseFloat(this.form.marriageLeaveUsed)
      this.form.maternityLeave = parseFloat(this.form.maternityLeave)
      this.form.maternityLeaveUsed = parseFloat(this.form.maternityLeaveUsed)
      this.form.funeralLeave = parseFloat(this.form.funeralLeave)
      this.form.funeralLeaveUsed = parseFloat(this.form.funeralLeaveUsed)
    },
    //保存
    async save(formValidate){
			this.$refs["formValidate"].validate(async valid => {
				if (valid) {
        let respone = null;
          if (this.type == "新增") {
            this.getParseInt()
            respone = await this.$Ajax.post(
              "/api/services/app/UserLeave/Create",
              this.form);
            this.$Message.success('操作成功!');
          } else {
            this.getParseInt()
            this.form.expirationTime = this.$moment(this.form.expirationTime).format("YYYY-MM-DD");
            respone = await this.$Ajax.put(
              "/api/services/app/UserLeave/Update",
              this.form)
              this.$Message.success('操作成功!');
          }
          this.cancels()
        }
      });
		},
    //关闭弹出框
    cancels() {
      this.$emit("close", { cancel: true });
      this.handTable('formValidate')
    },
    //根据ID获取详细信息
    async getInforID(id) {
      let respose = await this.$Ajax.get(
        "/api/services/app/UserLeave/Get",
        { params: { id: id } }
      );
      this.disabled = true
      respose.data.result.year = respose.data.result.year.toString()
      this.form = respose.data.result;
    }
  }
};
</script>
<style lang="less" scoped="scoped">

/deep/ .ivu-select-disabled .ivu-select-selection {
  background-color: #ffffff !important;
  opacity: 1;
  cursor: not-allowed;
  color: rgb(53, 53, 53) !important;
}
</style>

